import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ClipboardList, ChevronDown, ChevronUp } from "lucide-react";

export function LiveScorecard({ round, playedHoles, totalPar, showScorecard, setShowScorecard, courseHoles }) {
  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="w-full mb-4 border-[#1B4D3E] text-[#1B4D3E]"
        onClick={() => setShowScorecard(!showScorecard)}
        data-testid="toggle-scorecard-btn"
      >
        <ClipboardList className="w-4 h-4 mr-2" />
        {showScorecard ? "Ocultar Scorecard" : "Ver Scorecard"}
        {showScorecard ? <ChevronUp className="w-4 h-4 ml-2" /> : <ChevronDown className="w-4 h-4 ml-2" />}
      </Button>

      {showScorecard && (
        <Card className="card-default mb-4 overflow-hidden">
          <CardContent className="p-0">
            <div className="overflow-x-auto">
              <table className="w-full text-xs">
                <thead>
                  <tr className="bg-[#1B4D3E] text-white">
                    <th className="text-left py-2 px-2 sticky left-0 bg-[#1B4D3E] z-10 min-w-[60px]">Jugador</th>
                    {playedHoles.map(h => (
                      <th key={h.hole} className="text-center py-2 px-1 min-w-[28px]">{h.hole}</th>
                    ))}
                    <th className="text-center py-2 px-2 min-w-[32px] bg-[#163f33]">TOT</th>
                  </tr>
                  <tr className="bg-gray-100 text-[#64748B]">
                    <td className="py-1 px-2 sticky left-0 bg-gray-100 z-10 text-[10px] font-semibold">Par</td>
                    {playedHoles.map(h => (
                      <td key={h.hole} className="text-center py-1 px-1 text-[10px]">{h.par}</td>
                    ))}
                    <td className="text-center py-1 px-2 text-[10px] font-semibold">{totalPar}</td>
                  </tr>
                </thead>
                <tbody>
                  {round?.players?.map((player, pIdx) => {
                    let total = 0;
                    const playerPlayedHoles = courseHoles.filter((_, i) => player.scores?.some(s => s.hole_number === i + 1));
                    return (
                      <tr key={player.player_id} className={pIdx % 2 === 0 ? '' : 'bg-gray-50/50'}>
                        <td className={`py-1.5 px-2 sticky left-0 z-10 ${pIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                          <div className="flex items-center gap-1">
                            <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${player.is_base ? 'bg-[#1B4D3E]' : 'bg-[#D4A373]'}`}></span>
                            <span className="font-medium truncate max-w-[50px]">{player.name.split(' ')[0]}</span>
                          </div>
                        </td>
                        {playerPlayedHoles.map(h => {
                          const score = player.scores?.find(s => s.hole_number === h.hole);
                          const gross = score?.gross_score || 0;
                          total += gross;
                          const diff = gross - h.par;
                          const hasUnit = score?.has_unit && score?.unit_count > 0;
                          return (
                            <td key={h.hole} className={`text-center py-1.5 px-1 font-medium ${
                              diff < -1 ? 'text-amber-600 font-bold' :
                              diff < 0 ? 'text-green-600 font-bold' :
                              diff === 0 ? 'text-gray-700' :
                              diff === 1 ? 'text-red-500' : 'text-red-700 font-bold'
                            } ${hasUnit ? 'bg-[#D4A373]/15' : ''}`}>
                              {gross || '-'}
                            </td>
                          );
                        })}
                        <td className="text-center py-1.5 px-2 font-bold bg-gray-100">{total || '-'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}
